import i18next from "i18next";

import en from "./en.js";

i18next.addResourceBundle("en", "common", en);
